import { render, staticRenderFns } from "./CalendarEventFullDetail.vue?vue&type=template&id=b6591f22&scoped=true"
import script from "./CalendarEventFullDetail.vue?vue&type=script&lang=js"
export * from "./CalendarEventFullDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6591f22",
  null
  
)

export default component.exports